export default {
  init() {
    const medias = document.querySelectorAll('.ms-media');
    window.addEventListener('load', () => {
      this.initializeVideo(medias);
    });
  },
  initializeVideo(medias) {
    medias.forEach(media => {
      const figure = media.querySelector('.ms-media__figure');
      const video = media.querySelector('.ms-media__video');
      const playVideoButton = figure.querySelector('.ms-media__play-button');
      if (!video) return;

      const videoId = video.dataset.vidId;

      const playVideo = () => {

        if (!window.MSRecipeVideos) {
          return;
        }

        if (window.MSRecipeVideos[videoId].getPlayerState() !== window.YT.PlayerState.PLAYING) {
          window.MSRecipeVideos[videoId].playVideo();
          playVideoButton.setAttribute('aria-label', 'Pause Video');
        } else {
          window.MSRecipeVideos[videoId].pauseVideo();
          playVideoButton.setAttribute('aria-label', 'Play Video');
        }
      }

      playVideoButton.addEventListener('click', playVideo);
    });
  },
}



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/media.js